<div
  class="ButtonWrapper"
  [ngClass]="{
    'ButtonWrapper--Fit': config?.subnav,
    'ButtonWrapper--FullWidth': config?.size === ButtonSizes.fullWidth,
  }"
  [attr.data-test-id]="'ButtonWrapper'"
>
  <button
    type="button"
    class="button"
    [id]="config?.id || null"
    (click)="onClick($event)"
    [disabled]="isDisabled"
    [ngClass]="{
      'button--fit': config?.size === ButtonSizes.fit,
      'button--fullWidth': config?.size === ButtonSizes.fullWidth,
      'button--special': config?.level === ButtonLevels.special,
      'button--high': config?.level === ButtonLevels.high,
      'button--medium': config?.level === ButtonLevels.medium,
      'button--moderate': config?.level === ButtonLevels.moderate,
      'button--link': config?.level === ButtonLevels.link,
      'button--low': config?.level === ButtonLevels.low,
      'button--text': config?.level === ButtonLevels.text,
      'button--error': config?.level === ButtonLevels.error,
      'button--icon': config?.icon && !config?.content,
      'is-active': config?.active,
      'button--leftAligned': config?.leftAlignedText,
    }"
    tabindex="0"
    dataClickEvent
    (keydown.enter)="onClick($event)"
    role="button"
    [attr.data-test-id]="
      (innerHtmlContent || config?.icon) + 'ButtonContentWrapper'
    "
    [attr.data-analytics-name]="innerHtmlContent || ariaDescription"
    [attr.aria-label]="ariaDescription || innerHtmlContent || config?.icon"
    [attr.aria-controls]="ariaControls"
    [attr.aria-expanded]="ariaExpanded"
  >
    <div class="button__content" [attr.data-test-id]="'ButtonContent'">
      @if (config?.icon && !config?.isIconRight) {
        <icon
          class="button__icon"
          [name]="config?.icon"
          [config]="{ fill: iconFill, size: config?.iconSize || 'small' }"
          [attr.data-test-id]="'LeftButtonIcon'"
        >
        </icon>
      }

      @if (loading) {
        <ripple
          class="button__icon"
          size="small"
          [flexCenter]="true"
          [isFullPage]="false"
          [attr.data-test-id]="'RippleLoadingIcon'"
        ></ripple>
      } @else {
        @if (config?.content) {
          <span
            class="button__content--text"
            [innerHTML]="innerHtmlContent"
            [attr.data-test-id]="'ButtonText'"
          >
          </span>
        }
      }

      @if (config?.icon && config?.isIconRight) {
        <icon
          class="button__icon"
          [name]="config?.icon"
          [config]="{
            fill: iconFill,
            format: config.iconFormat ? config.iconFormat : 'svg',
            size: config.iconSize ? config.iconSize : 'small',
          }"
          [attr.data-test-id]="'RightButtonIcon'"
        >
        </icon>
      }
    </div>
  </button>

  @if (config?.subnav && buttonSubnavShows) {
    <div
      class="button__subnav"
      [attr.data-test-id]="'Subnav'"
      [ngClass]="{
        'button__subnav--right': config?.menuPosition === SubNavPositions.right,
        'button__subnav--top': config?.menuPosition === SubNavPositions.top,
        'button__subnav--left': config?.menuPosition === SubNavPositions.left,
      }"
    >
      @for (subnavItem of config?.subnav?.items; track subnavItem) {
        <button
          role="button"
          tabindex="0"
          [attr.aria-label]="subnavItem.label"
          class="button__subnav__row"
          (click)="onClick(subnavItem.prop, 'subnav')"
          (keydown.enter)="onClick(subnavItem.prop, 'subnav')"
          [attr.data-test-id]="subnavItem.label + 'SubnavRow'"
        >
          @if (subnavItem.icon) {
            <icon [name]="subnavItem.icon"> </icon>
          }
          <p [innerHTML]="subnavItem.label"></p>
        </button>
      }
    </div>
  }
</div>
